export const STATUS_LABEL = {
  agendada: "Agendada",
  deslocamento: "Em deslocamento",
  andamento: "Em andamento",
  finalizada: "Finalizada",
  cancelada: "Cancelada",
};

export const ROLE_LABEL = {
  admin: "Administrador",
  supervisor: "Supervisão",
  collaborator: "Colaborador",
};

export function brl(v) {
  return (Number(v) || 0).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}

export function fmtDateTime(s) {
  if (!s) return "—";
  const d = new Date(s);
  // Padrão americano: MM/DD/YYYY · 12h AM/PM
  return d.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function fmtDate(s) {
  if (!s) return "—";
  return new Date(s).toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
}

export function fmtTime(s) {
  if (!s) return "—";
  return new Date(s).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

/**
 * Converte uma string crua "HH:MM" (24h) para o formato americano 12h.
 * Ex: "06:00" → "6:00 AM" · "14:30" → "2:30 PM" · "00:15" → "12:15 AM".
 * Aceita também "HH:MM:SS" e ignora valores inválidos (retorna o original).
 */
export function to12h(hhmm) {
  if (!hhmm) return "";
  const m = String(hhmm).match(/^(\d{1,2}):(\d{2})/);
  if (!m) return String(hhmm);
  let h = parseInt(m[1], 10);
  const min = m[2];
  if (Number.isNaN(h) || h < 0 || h > 23) return String(hhmm);
  const period = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${min} ${period}`;
}

export function durationMin(min) {
  if (!min && min !== 0) return "—";
  if (min === 0) return "<1min";
  const h = Math.floor(min / 60);
  const m = min % 60;
  return h > 0 ? `${h}h ${m}min` : `${m}min`;
}

/**
 * Calcula duração em minutos a partir de start_time e end_time ISO strings.
 * Útil quando o backend não armazenou duration_minutes.
 */
export function computeDurationMin(start, end) {
  if (!start || !end) return null;
  try {
    const a = new Date(start).getTime();
    const b = new Date(end).getTime();
    if (Number.isNaN(a) || Number.isNaN(b) || b <= a) return null;
    return Math.max(1, Math.round((b - a) / 60000));
  } catch {
    return null;
  }
}

// US phone formatter: "+1 (XXX) XXX-XXXX"
export function formatUSPhone(input) {
  if (!input) return "";
  let digits = String(input).replace(/\D/g, "");
  if (digits.startsWith("1") && digits.length === 11) digits = digits.slice(1);
  digits = digits.slice(0, 10);
  const a = digits.slice(0, 3);
  const b = digits.slice(3, 6);
  const c = digits.slice(6, 10);
  if (digits.length === 0) return "";
  if (digits.length < 4) return `(${a}`;
  if (digits.length < 7) return `(${a}) ${b}`;
  return `(${a}) ${b}-${c}`;
}

export function usPhoneE164(input) {
  const d = String(input || "").replace(/\D/g, "").slice(-10);
  return d.length === 10 ? `+1${d}` : "";
}

// ===========================================================================
// US date/time formatters (timezone do navegador — Eastern para usuários US)
// ===========================================================================

/**
 * Formata uma string ISO como data americana ex: "Jun 10, 2026" no fuso local.
 * Resolve o problema de exibir datas UTC um dia adiantado.
 */
export function fmtUSDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  } catch {
    return iso;
  }
}

/** Versão longa: "Wednesday, Jun 10, 2026" */
export function fmtUSDateLong(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  } catch {
    return iso;
  }
}

/** Hora 12h estilo americano: "11:09 PM" no fuso local. */
export function fmtUSTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return iso;
  }
}

/** Data + hora US: "Jun 10, 2026, 11:09 PM" no fuso local. */
export function fmtUSDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return iso;
  }
}

/**
 * Chave de agrupamento por dia no fuso local (YYYY-MM-DD).
 * NÃO use `iso.split("T")[0]` — isso pega UTC e desloca a data.
 */
export function localDateKey(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  } catch {
    return "—";
  }
}
